import { ForwardedRef, forwardRef } from 'react';

import { SimpleSearchSelect } from '~src/components/SimpleSearchSelect/SimpleSearchSelect';
import { useLocalizedCountryList } from '~src/i18n/localized-country';
import { useTranslation } from '~src/i18n/use-translation';

interface Props {
  onChange: (value: string) => void;
  value: string | undefined;
  invalid?: boolean;
}

function CountrySelectElement({ value, invalid, onChange }: Props, ref: ForwardedRef<HTMLButtonElement>) {
  const countries = useLocalizedCountryList();
  const { t } = useTranslation();

  return (
    <SimpleSearchSelect
      placeholder={t('common.selectCountry')}
      onValueChange={value => onChange(value[0])}
      value={value ? [value] : undefined}
      options={countries}
      invalid={invalid}
      ref={ref}
    />
  );
}

export const CountrySelect = forwardRef(CountrySelectElement);
